export default "__VITE_ASSET__B4EaGMI3__"